import React, { useCallback } from "react";
import T from "prop-types";

import { PeriodYear } from "2g-period";

export function PeriodYearControlled({
  value = {},
  onChange: onChangeIncomming,
  min,
  max
}) {
  const onChange = useCallback(
    (yearFrom, yearTo) => {
      onChangeIncomming({ yearFrom, yearTo });
    },
    [onChangeIncomming]
  );
  return (
    value.yearFrom &&
    min !== max && (
      <PeriodYear
        from={value.yearFrom}
        to={value.yearTo}
        onChange={onChange}
        min={min}
        max={max}
      />
    )
  );
}

PeriodYearControlled.propTypes = {
  value: T.shape({
    yearFrom: T.number,
    yearTo: T.number
  }),
  onChange: T.func.isRequired,
  min: T.number,
  max: T.number
};

export default React.memo(PeriodYearControlled);
